import { Icon, InputCheckbox, ListItem, Stack, Text } from "@bookingcom/bui-react";
import { PlaneTripInternationalIcon } from "@bookingcom/bui-assets-react/streamline";
import { t, useI18n } from "@bookingcom/lingojs-react";
import type { UserAirlineGroupEntry } from "../../types";
import styles from "./AirlineGroupSelector.module.css";

type AirlineGroupSelectorGroupListItemProps = {
  entry: UserAirlineGroupEntry;
  isGroupSelected?: boolean;
  isGroupAirlinesSelected?: boolean;
  disabled?: boolean;
  onChange?: () => void;
};

export const AirlineGroupSelectorGroupListItem = ({
  entry,
  isGroupSelected = false,
  isGroupAirlinesSelected = false,
  disabled = false,
  onChange,
}: AirlineGroupSelectorGroupListItemProps) => {
  const i18n = useI18n();
  const groupName = entry.group?.name ?? "";
  const noOfAirlines = entry.airlines.length;

  return (
    <ListItem spacing="small" className={styles.listItem}>
      <Stack direction="row" mixin={{ padding: 3 }} className={isGroupAirlinesSelected ? styles.listItemSelected : undefined}>
        <Icon svg={PlaneTripInternationalIcon} />
        <Stack gap={1} grow>
          <InputCheckbox
            className={styles.listItemCheckbox}
            name={`group-${groupName}`}
            label={<Text variant="emphasized_2">{groupName}</Text>}
            checked={isGroupSelected}
            indeterminate={!isGroupSelected && isGroupAirlinesSelected}
            disabled={disabled}
            onChange={onChange}
          />
          <Text variant="small_1">
            {i18n.trans(
              t("flights_airline_portal_admin_group_view_selector_number_airlines", {
                variables: {
                  num_airlines: noOfAirlines,
                  num_exception: noOfAirlines,
                },
              })
            )}
          </Text>
        </Stack>
      </Stack>
    </ListItem>
  );
};
